import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-completed-page',
  standalone: false,
  templateUrl: './custom-completed-page.component.html',
  styleUrl: './custom-completed-page.component.scss',
})
export class CustomCompletedPageComponent implements OnInit {
  data: {
    customTitle: string;
    customMessage: string;
  };

  ngOnInit(): void {
    // this custom component will allow us to run custom group calls for any
    // specific data if there is a need for it.

    this.data = {
      customTitle: 'Case Submitted Successfully',
      customMessage:
        'Thank you for submitting your case. Please close this page and continue your workflow.',
    };
  }
}
